/**
 * UTM models
 * This file contains the core UTM models as OpenAPI 2.0 compliant definitions. Some key caveats when using/referencing this API:   1. The API on its own is insufficeint to develop a USS or other UTM   component.  For example, the USS Specification is needed to understand   how and when to use the various endpoints and provides more details on   security features that cannot be captured in the API docs.   2. There is not a unified time synchronization approach in UTM currently.   As such, times provided from one server MUST NOT be validated against each other.   For example, if a sending server states that a data element   was sent at 10:00:23, but the receiving server thinks it is currently   10:00:22, the receiving server must not reject the data submission.  As   we develop and roll out the time synchronization scheme for the USS   Network, we will add appropriate validation requirements to the API   documentation.   3. On the contrary, times must be validated for consistency within a   given data submission.  For example, if a server states that it sends   a data instance at 10:00:23 and one of the other data elements states   that a measurement was performed at 10:00:24, then the receiving server   must reject that data submission. Some of these checks are explictly   stated in the descriptions below. If you recognize any such checks that   are not documented, please submit an issue report on github.   4. These token SUBJECT validations are required for security.   For PUT Operation to modify an existing operation, the token SUBJECT claim upon modification MUST equal the token SUBJECT claim for the initial Operation.   For PUT Message associated with an Operation gufi, the token SUBJECT claim used for PUT Message MUST equal the token SUBJECT claim for the initial operation.     This check is performed if the initial operation exists, so as to not preclude receiving emergency messages.   For PUT Position associated with an Operation gufi, the token SUBJECT claim used for PUT Position MUST equal the token SUBJECT claim for the initial operation.     This check is performed only if the initial operation exists, so as to not preclude receiving emergency position reports.
 *
 * The version of the OpenAPI document: v4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface IEventMetadata { 
    /**
     * If true these data are intended for Data Collection. Essentially stating if particular data should be ignored during analysis. This may be modified after submission in the case that there was an issue during execution of the test/experiment that would invalidate the data that were collected.
     */
    data_collection: boolean;
    /**
     * A string tag indicating which event this operation is associated. Will be used to select a set of rules for validation.
     */
    event_id: string;
    /**
     * Proper formatting for SOW scenarios is \"SCENARIO_n\" where n is 1-5. For other scenarios, the appropriate value should be provided by the POC for that activity.
     */
    scenario: string;
    /**
     * The name or number of the test card.  In many cases, a scenario will have only one test_card, but it is possible that there are multiple test_cards for a given scenario.
     */
    test_card: string;
    /**
     * An identifier for a specific run of a test_card.  In many cases, a test_card may be only run once.  However, it is possible that a test_card is run multiple times.
     */
    test_run: string;
    /**
     * Expected values: a call sign, test card role, or flight ID that links this operation to a particular test card flight. As an example, in our TCL2 demo, \"GCS3\" could have been used here. For multiple flights emanating from one location on a test card, this data element could include further information to link the operation to the test card flight, such as GCS1A. Every operation requires a call_sign that is pre-determined in the full test card description.
     */
    call_sign: string;
    /**
     * Test type. Note a GROUND test may use a physical vehicle and a FLIGHT test may use a simulated vehicle.  This is the reason for separating test_type from source.
     */
    test_type: IEventMetadata.TestTypeEnum;
    /**
     * Hardware-in-the-loop (HWITL) flights refer to ground or airborne flights. Software-in-the loop (SWITL) flights would be used to tag flights do not use a physical vehicle, whether or not there is a full-featured simulation involved.
     */
    source: IEventMetadata.SourceEnum;
    /**
     * Name of the testing location, such as NV, Moffett, Crows Landing, etc.  The supplier of the metadata should use a constant value for this field when the same location is used mulitple times across data submissions. E.g. \"AMES\" should always be \"AMES\" and not \"ames\" or \"Ames\" or \"NASA Ames\" at other various times.
     */
    location: string;
    /**
     * Test setting. Note that a LAB setting may involve HWITL source and FIELD settings may involve SWITL sources.  LAB settings may have GROUND or FLIGHT tests, same with FIELD settings.
     */
    setting: IEventMetadata.SettingEnum;
    /**
     * Free text may be included with the original submission and/or added by a data_quality_engineer.  In the latter case, all previous free_text should be preserved, i.e. the data_quality_engineer should only append to the free_text field.
     */
    free_text?: string;
    /**
     * Email address of author handling data quality issue. If multiple individuals modify this metadata, this field will only hold the last such individual.  In that case, the engineer should make an effort to document as much as possible in the free_text field. SHOULD NOT be included wth an operation.  This element is populated by NASA as needed.
     */
    data_quality_engineer?: string;
    /**
     * This metadata was modified from its original submission by a data_quality_engineer. SHOULD NOT be included wth an operation.  This element is populated by NASA as needed.
     */
    modified?: boolean;
}
export namespace IEventMetadata {
    export type TestTypeEnum = 'GROUND' | 'FLIGHT';
    export const TestTypeEnum = {
        GROUND: 'GROUND' as TestTypeEnum,
        FLIGHT: 'FLIGHT' as TestTypeEnum
    };
    export type SourceEnum = 'HWITL' | 'SWITL';
    export const SourceEnum = {
        HWITL: 'HWITL' as SourceEnum,
        SWITL: 'SWITL' as SourceEnum
    };
    export type SettingEnum = 'LAB' | 'FIELD';
    export const SettingEnum = {
        LAB: 'LAB' as SettingEnum,
        FIELD: 'FIELD' as SettingEnum
    };
}


